import { SelectModule } from '../select/select.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddNewCustomFrameworkComponent } from './add-new-custom-framework.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CygovButtonModule } from '../cygov-button/cygov-button.module';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  imports: [CommonModule, SvgIconModule, FormsModule, SelectModule, NgbModule, CygovButtonModule, FileUploadModule],
  declarations: [AddNewCustomFrameworkComponent],
  exports: [AddNewCustomFrameworkComponent],
})
export class AddNewCustomFrameworkModule {}
